import OrganizationScreen from './OrganizationScreen';
import wrapInTabContentContainer from '../../../AppNavigator/TabNavigation/wrapInTabContentContainer';
import AddOrganizationInvitationScreen from './AddOrganizationInvitationScreen';
import OrganizationInvitationScreen from './OrganizationInvitationScreen';
import UserScreen from './UserScreen';
import EditUserScreen from './EditUserScreen';
import InvitationDefinitionScreen from './InvitationDefinitionScreen';
import AddInvitationDefinitionScreen from './AddInvitationDefinitionScreen';
import EditInvitationDefinitionScreen from './EditInvitationDefinitionScreen';
import GroupScreen from './GroupScreen';
import AddGroupScreen from './AddGroupScreen';
import EditGroupScreen from './EditGroupScreen';
import EditClientBillingBrandingScreen from './EditClientBillingBrandingScreen';

const screens = {
    OrganizationScreen: wrapInTabContentContainer(OrganizationScreen),
    AddOrganizationInvitationScreen: wrapInTabContentContainer(AddOrganizationInvitationScreen),
    OrganizationInvitationScreen: wrapInTabContentContainer(OrganizationInvitationScreen),
    UserScreen: wrapInTabContentContainer(UserScreen),
    EditUserScreen: wrapInTabContentContainer(EditUserScreen),
    AddGroupScreen: wrapInTabContentContainer(AddGroupScreen),
    EditGroupScreen: wrapInTabContentContainer(EditGroupScreen),
    GroupScreen: wrapInTabContentContainer(GroupScreen),
    InvitationDefinitionScreen: wrapInTabContentContainer(InvitationDefinitionScreen),
    AddInvitationDefinitionScreen: wrapInTabContentContainer(AddInvitationDefinitionScreen),
    EditInvitationDefinitionScreen: wrapInTabContentContainer(EditInvitationDefinitionScreen),
    EditClientBillingBrandingScreen: wrapInTabContentContainer(EditClientBillingBrandingScreen),
};

export { screens };
